export const storageKeyOffer = 'offer' as const;
export const storageKeyOfferValue = 'privacy-protection' as const;

export const addOfferToLocalStorage = () => {
  const utmParams = new URLSearchParams(window.location.search);
  const offer = utmParams.get(storageKeyOffer);
  if (offer) {
    localStorage.removeItem(storageKeyOffer);
  }
};

// ==============================

export const DBOO_RESULTS_PRIVACY_URL = 'https://www.aura.com/dboo-scan';

export const getBuyAuraUrlResultsPage = () => {
  return DBOO_RESULTS_PRIVACY_URL;
};

// ==============================

export const DBOO_FINISH_PRIVACY_URL = 'https://www.aura.com/dboo-scan';

export const getBuyAuraUrlFinishPage = () => {
  return DBOO_FINISH_PRIVACY_URL;
};
